import { render, staticRenderFns } from "./TimePickerV1Properties.vue?vue&type=template&id=b92c3272&"
import script from "./TimePickerV1Properties.vue?vue&type=script&lang=js&"
export * from "./TimePickerV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports